module.exports = __webpack_public_path__ + "media/images/Primary_Okra-ef51c4b66ca68b337a8eb4a4a8993fa4.svg";